import { registerComponent } from '@gig/magic-common';
import { RewardPrompterComponent } from './reward-prompter.js';

var RewardPrompter = registerComponent(RewardPrompterComponent);

export { RewardPrompter };
